import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    className?: string;
    href: string;
    title: string;
    onClick?: () => void;
}

const BaseLinkButton = ({ className, href, onClick, title }: IProps) => (
    <a className={className} href={href} rel="noreferrer" onClick={onClick}>
        {title}
    </a>
);

export const LinkButton = styled(BaseLinkButton)`
    appearance: none;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.white};
    background-color: ${colors.orange};
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    padding: 0.5rem 1.5rem;
    min-width: 176px;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
        background-color: ${colors.orangeHover};
    }
`;
